import {AdditionalInputText} from "../../../components/AdditionalInputText";
import bannerCreator from "../banner/banner.creator.module.scss"

interface Props {
    bannerText: string;
    bannerTextNumber: string;
    setBannerText: (_: string) => void;
}

export default function BannerFirTextField({bannerText, setBannerText, bannerTextNumber}: Props) {

    return (
        <AdditionalInputText
            bannerText={bannerText}
            bannerTextNumber={bannerTextNumber}
            setBannerText={setBannerText}
            additionText={
                <span className={bannerCreator.lowerText}>
                        * 배너 상단문구 : 32px(PC)/24px(MO), lite체
                    </span>
            }
        />
    );
};